export default class Callback {
    constructor() {
      this.activeIndex = -1

      this.bindMethods()
      this.getElems()
      this.events()
    }

    bindMethods() {
        this.launchPopup = this.launchPopup.bind(this)
        this.onFormSubmit = this.onFormSubmit.bind(this)
        this.onCloseClick = this.onCloseClick.bind(this)
    }

    getElems() {
        this.buttons = document.querySelectorAll('.w4c-button')
    }

    events() {
      for (let i = 0; i < this.buttons.length; i++) {
        this.buttons[i] && this.buttons[i].addEventListener('click', this.launchPopup.bind(this, i))
      }
    }

    launchPopup(index) {
      this.activeIndex = index
      this.createForm()
      this.form.addEventListener('submit', this.onFormSubmit)
    }

    onCloseClick() {
        this.container.remove()
    }

    onFormSubmit(e) {
        e.preventDefault()
        this.errorText = this.buttons[this.activeIndex].querySelector('.error-text')

        this.phoneValue = this.input.value.split(' ').join('')

        const mode = 'production';
        const address = mode === 'production' ? 'https://w4c.widget4call.fr' : 'https://app-e9f27118-96ff-4c6b-8660-31eac15ccbb5.cleverapps.io'
        const callbackUrl = address + '/fr/place-call'
        const phoneValid = this.validatePhone()

        this.errorElement.textContent = ''

        const params = {
            'widgetId': '60093cdf9b23c72e048b4568',
            'phone_number': this.phoneValue
        }

        if (phoneValid !== true) {
            this.errorElement.textContent = phoneValid

            return
        }

        this.submit.setAttribute('disabled', true)
        this.entry.classList.add('hide')
        this.outer.classList.add('show')

        $.post(callbackUrl, params, (data) => {
            const json = jQuery.parseJSON(data)

            if (json.status !== 'OK') {
                this.outerMessage.textContent = this.errorText.textContent
            }
        })
    }

    validatePhone() {
        const phone = this.phoneValue
        const pattern = /^[0][12345679]([0-9]{8})$/

        if (!phone.match(pattern)) return 'Le numéro de téléphone n\'est pas valide'

        return true
    }

    createForm() {
        this.entryText = this.buttons[this.activeIndex].querySelector('.entry-text')
        this.outputText = this.buttons[this.activeIndex].querySelector('.output-text')

        const formEntry = document.createElement('div')
        const formOuter = document.createElement('div')
        const container = document.createElement('div')
        const wrapper = document.createElement('div')
        const background = document.createElement('div')
        const form = document.createElement('form')
        const label = document.createElement('label')
        const input = document.createElement('input')
        const submit = document.createElement('input')
        const submitWrapper = document.createElement('div')
        const error = document.createElement('div')
        const outerMessage = document.createElement('div')
        const close = this.createClose()

        container.classList.add('w4c')
        wrapper.classList.add('w4c__wrapper')
        background.classList.add('w4c__background')
        form.classList.add('w4c__form')
        submitWrapper.classList.add('w4c__submit-wrapper')
        error.classList.add('w4c__error')
        formEntry.classList.add('w4c__form-entry')
        formOuter.classList.add('w4c__form-outer')

        label.setAttribute('for', 'phone')
        label.textContent = this.entryText.textContent

        outerMessage.textContent = this.outputText.textContent

        input.setAttribute('type', 'tel')
        input.setAttribute('id', 'phone')
        input.setAttribute('name', 'phone')
        input.setAttribute('required', true)

        submit.setAttribute('type', 'submit')
        submit.setAttribute('value', 'Valider')

        submitWrapper.appendChild(submit)

        form.appendChild(label)
        form.appendChild(input)
        form.appendChild(error)
        form.appendChild(submitWrapper)

        formEntry.appendChild(form)
        formOuter.appendChild(outerMessage)

        wrapper.appendChild(formEntry)
        wrapper.appendChild(formOuter)
        wrapper.appendChild(close)

        container.appendChild(background)
        container.appendChild(wrapper)

        document.body.appendChild(container)

        this.container = container
        this.form = form
        this.input = input
        this.submit = submit
        this.errorElement = error
        this.entry = formEntry
        this.outer = formOuter
        this.outerMessage = this.outerMessage
    }

    createClose() {
        const close = document.createElement('div')
        const closeSpan1 = document.createElement('span')
        const closeSpan2 = document.createElement('span')

        close.classList.add('w4c__close')

        close.appendChild(closeSpan1)
        close.appendChild(closeSpan2)
        close.addEventListener('click', this.onCloseClick)

        return close
    }
}



// WEBPACK FOOTER //
// ./scripts/util/Callback.js